import { ElementRef, ForwardedRef, forwardRef } from 'react';
import {
    DrawerBody,
    DrawerBodyProps,
    DrawerCancel,
    DrawerCancelProps,
    DrawerClose,
    DrawerCloseProps,
    DrawerContent as DrawerContentPrimitive,
    DrawerContentProps,
    DrawerFooter,
    DrawerFooterProps,
    DrawerHeader,
    DrawerHeaderProps,
    DrawerRoot,
    DrawerRootProps,
    DrawerSkeleton,
    DrawerSkeletonProps,
    DrawerTitle,
    DrawerTitleProps,
    DrawerTrigger,
    DrawerTriggerProps,
} from '@givebutter/primitives/drawer';
import { TOAST_VIEWPORT_ID } from '@givebutter/primitives/toast';

const DrawerContent = forwardRef(
    (
        { onInteractOutside, ...rest }: DrawerContentProps,
        forwardedRef: ForwardedRef<ElementRef<typeof DrawerContentPrimitive>>,
    ) => {
        return (
            <DrawerContentPrimitive
                ref={forwardedRef}
                onInteractOutside={e => {
                    const isFocusIn = e.detail.originalEvent.type === 'focusin';
                    const possibleTarget = e.currentTarget as HTMLElement | null;
                    const possibleTinyNode = possibleTarget?.closest('.tox');
                    const possibleToast = possibleTarget?.closest(`#${TOAST_VIEWPORT_ID}`);

                    let possibleCanvaNode = false;
                    const iframes = document.querySelectorAll('iframe');
                    iframes.forEach(iframe => {
                        const src = iframe.getAttribute('src');
                        if (src?.includes('canva')) {
                            possibleCanvaNode = true;
                        }
                    });

                    if (isFocusIn || possibleTinyNode || possibleCanvaNode || possibleToast) {
                        e.preventDefault();
                    }

                    onInteractOutside?.(e);
                }}
                {...rest}
            />
        );
    },
);

const Root = DrawerRoot;
const Trigger = DrawerTrigger;
const Content = DrawerContent;
const Header = DrawerHeader;
const Title = DrawerTitle;
const Close = DrawerClose;
const Body = DrawerBody;
const Footer = DrawerFooter;
const Cancel = DrawerCancel;
const Skeleton = DrawerSkeleton;

export {
    DrawerRoot,
    DrawerTrigger,
    DrawerContent,
    DrawerHeader,
    DrawerTitle,
    DrawerClose,
    DrawerBody,
    DrawerFooter,
    DrawerCancel,
    DrawerSkeleton,
    //
    Root,
    Trigger,
    Content,
    Header,
    Title,
    Close,
    Body,
    Footer,
    Cancel,
    Skeleton,
};
export type {
    DrawerRootProps,
    DrawerHeaderProps,
    DrawerFooterProps,
    DrawerTitleProps,
    DrawerSkeletonProps,
    DrawerCloseProps,
    DrawerBodyProps,
    DrawerContentProps,
    DrawerCancelProps,
    DrawerTriggerProps,
};
